import { Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import useIcons from "../../hooks/useIcons";
import useThemeColors from "../../hooks/useThemeColors";
import CustomButton from "./CustomButton";
import FormNavigationLinks from "./FormNavigationLinks";
import TextInput from "./TextInput";

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: any;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  loading: boolean;
  schoolName: string;
  schoolAddress: string;
  schoolPhoneNumber: string;
  schoolEmail?: string;
  schoolWebsite?: string;
  isNextDisabled?: boolean;
}

function SchoolInfoRegForm({
  handleChange,
  errors,
  handleNextStep,
  handlePreviousStep,
  loading,
  schoolName,
  schoolAddress,
  schoolPhoneNumber,
  schoolEmail,
  schoolWebsite,
  isNextDisabled = false,
}: Props) {
  const colors = useThemeColors();
  const icons = useIcons();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleNextStep();
  };

  return (
    <VStack w={"full"}>
      <form onSubmit={handleSubmit} style={{ width: "100%" }}>
        <Stack gap={4}>
          <TextInput
            placeholder="School Name *"
            name="schoolName"
            value={schoolName}
            onChange={handleChange}
            error={errors.schoolName}
            required
            invalid={!!errors.schoolName}
          />

          <TextInput
            placeholder="School Address *"
            name="schoolAddress"
            value={schoolAddress}
            onChange={handleChange}
            error={errors.schoolAddress}
            required
            invalid={!!errors.schoolAddress}
          />

          <TextInput
            placeholder="School Phone Number *"
            name="schoolPhoneNumber"
            value={schoolPhoneNumber}
            onChange={handleChange}
            error={errors.schoolPhoneNumber}
            required={true}
            startElement={<Text>+234</Text>}
          />

          <TextInput
            placeholder="School Email"
            name="schoolEmail"
            value={schoolEmail || ""}
            onChange={handleChange}
            error={errors.schoolEmail}
            invalid={!!errors.schoolEmail}
            type="email"
          />

          <TextInput
            placeholder="School Website"
            name="schoolWebsite"
            value={schoolWebsite || ""}
            onChange={handleChange}
            error={errors.schoolWebsite}
            invalid={!!errors.schoolWebsite}
            startElement={<Text>https://</Text>}
          />

          <CustomButton
            w={"full"}
            type="submit"
            label="Next"
            loading={loading}
            disabled={loading || isNextDisabled}
            colorPalette={colors.brand.primary}
          />

          <FormNavigationLinks
            links={[
              {
                text: "Go Back",
                onClick: handlePreviousStep,
                icon: icons.utility.arrowLeft,
                isDisabled: loading,
              },
            ]}
          />
        </Stack>
      </form>
    </VStack>
  );
}

export default SchoolInfoRegForm;
